import { computed, unref } from '@vue/composition-api'
import { useStoreGetters } from '@/store'
import useRouter from '@/router/useRouter'
import { noExtendSessionPaths } from '@/utils/regex'

function useLoginStatus () {
  const { currentUser } = useStoreGetters('user', 'currentUser')
  const { route } = useRouter()
  const showLoggedInContent = computed(() => {
    return !(Object.values(noExtendSessionPaths).some(path => path.test(unref(route).path))) && Object.keys(unref(currentUser)).length > 0
  })
  return { showLoggedInContent }
}

export default useLoginStatus
